// Galerie photo des teases véhicules (DA) :
//  - met à jour le compteur « 01 / 04 » au changement de slide ;
//  - clic sur la photo -> ouvre la fiche véhicule (sauf flèches / pastilles / swipe).

const SELECTOR = '[data-car-gallery]'
const PAD_LENGTH = 2
const DRAG_THRESHOLD = 6

const pad2 = (n) => String(n).padStart(PAD_LENGTH, '0')

const isSwiperControl = (node) =>
  node instanceof Element &&
    node.classList.contains('swiper-button-next') ||
    node instanceof Element &&
    node.classList.contains('swiper-button-prev') ||
    node instanceof Element &&
    node.classList.contains('swiper-pagination-bullet') ||
    node instanceof Element &&
    node.classList.contains('swiper-pagination')

const initGallery = (wrapper) => {
  const swiperEl = wrapper.querySelector('swiper-container.alpha-image-gallery')
  const countEl = wrapper.querySelector('[data-car-gallery-count]')
  const href = wrapper.dataset.href

  // Compteur
  if (swiperEl && countEl) {
    swiperEl.addEventListener('swiperslidechange', (event) => {
      const swiper = event.detail && event.detail[0]
      if (!swiper) {
        return
      }
      const total = swiper.slides && swiper.slides.length || 1
      countEl.textContent = `${pad2(swiper.realIndex + 1)} / ${pad2(total)}`
    })
  }

  // Clic photo -> fiche (on ignore les contrôles Swiper et les drags)
  if (href) {
    let downX = null
    let downY = null

    wrapper.addEventListener('pointerdown', (event) => {
      downX = event.clientX
      downY = event.clientY
    })

    wrapper.addEventListener('click', (event) => {
      const moved = downX !== null &&
        (Math.abs(event.clientX - downX) > DRAG_THRESHOLD || Math.abs(event.clientY - downY) > DRAG_THRESHOLD)
      downX = null
      downY = null
      if (moved) {
        return
      }
      if (event.composedPath().some(isSwiperControl)) {
        return
      }
      window.location.href = href
    })
  }
}

const initCarTeaseGalleries = () => {
  document.querySelectorAll(SELECTOR).forEach(initGallery)
}

if (document.readyState !== 'loading') {
  initCarTeaseGalleries()
} else {
  document.addEventListener('DOMContentLoaded', initCarTeaseGalleries)
}

export {
  initCarTeaseGalleries
}
